import AuthService from '../../services/AuthService'

const state = {
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user')) || null,
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  currentUser: state => state.user
}

const actions = {
  async login({ commit }, credentials) {
    console.log('Store login action called with:', credentials)
    commit('auth_request')
    try {
      const response = await AuthService.login(credentials)
      console.log('AuthService response:', response)
      const { token, usuario } = response.data
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(usuario))
      commit('auth_success', { token, user: usuario })
      return response
    } catch (error) {
      console.error('Store login error:', error)
      commit('auth_error')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      throw error
    }
  },

  async forgotPassword({ commit }, email) {
    try {
      const response = await AuthService.forgotPassword(email)
      return response
    } catch (error) {
      throw error
    }
  },

  async resetPassword({ commit }, { token, password }) {
    try {
      const response = await AuthService.resetPassword(token, password)
      return response
    } catch (error) {
      throw error
    }
  },

  async changePassword({ commit }, { currentPassword, newPassword }) {
    try {
      const response = await AuthService.changePassword(currentPassword, newPassword)
      return response
    } catch (error) {
      throw error
    }
  },
  
  async getProfile({ commit }) {
    try {
      const response = await AuthService.getProfile()
      const user = response.data.data
      localStorage.setItem('user', JSON.stringify(user))
      commit('update_user', user)
      return response
    } catch (error) {
      throw error
    }
  },
  
  async updateProfile({ commit, state }, profileData) {
    try {
      const userId = state.user.ID_USUARIO || state.user.id
      const response = await AuthService.updateProfile(userId, profileData)
      const user = response.data.data
      
      // Actualizar el usuario en localStorage y en el estado
      const updatedUser = { ...state.user, ...user }
      localStorage.setItem('user', JSON.stringify(updatedUser))
      commit('update_user', updatedUser)
      
      return response
    } catch (error) {
      throw error
    }
  },

  logout({ commit }) {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      resolve()
    })
  }
}

const mutations = {
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  auth_error(state) {
    state.status = 'error'
    state.token = ''
    state.user = null
  },
  update_user(state, user) {
    state.user = user
  },
  logout(state) {
    state.status = ''
    state.token = ''
    state.user = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}